import type {
  DangerReason,
  DeepLinkKind,
  EntityStatus,
  EntityType,
  PlanStatus,
  PlanStepStatus,
} from "./types";

export const ENTITY_TYPE_KEYS: Record<EntityType, string> = {
  STREAM: "partnerAssistant.card.entity.stream",
  VIDEO: "partnerAssistant.card.entity.video",
  COLLECTION: "partnerAssistant.card.entity.collection",
  PRODUCT: "partnerAssistant.card.entity.product",
  PROMOCODE: "partnerAssistant.card.entity.promocode",
  LINK: "partnerAssistant.card.entity.link",
  COVER: "partnerAssistant.card.entity.cover",
  PAGE: "partnerAssistant.card.entity.page",
};

export const ENTITY_STATUS_KEYS: Record<EntityStatus, string> = {
  PUBLISHED: "partnerAssistant.card.status.published",
  DRAFT: "partnerAssistant.card.status.draft",
  SCHEDULED: "partnerAssistant.card.status.scheduled",
  FINISHED: "partnerAssistant.card.status.finished",
};

export const DEEP_LINK_KEYS: Record<DeepLinkKind, string> = {
  DASHBOARD: "partnerAssistant.deepLink.dashboard",
  SALES: "partnerAssistant.deepLink.sales",
  VIEWS: "partnerAssistant.deepLink.views",
  USERS_ANALYTICS: "partnerAssistant.deepLink.usersAnalytics",
  PAYMENTS: "partnerAssistant.deepLink.payments",
  PURCHASES: "partnerAssistant.deepLink.purchases",
  SUBSCRIPTIONS: "partnerAssistant.deepLink.subscriptions",
  REFUNDS: "partnerAssistant.deepLink.refunds",
  DISPUTES: "partnerAssistant.deepLink.disputes",
  PROMOCODES: "partnerAssistant.deepLink.promocodes",
  REQUESTS: "partnerAssistant.deepLink.requests",
  CONVERSATIONS: "partnerAssistant.deepLink.conversations",
  VIDEOS: "partnerAssistant.deepLink.videos",
  STREAMS: "partnerAssistant.deepLink.streams",
  COLLECTIONS: "partnerAssistant.deepLink.collections",
  PRODUCTS: "partnerAssistant.deepLink.products",
};

export const PLAN_STATUS_KEYS: Record<PlanStatus, string> = {
  DRAFT: "partnerAssistant.plan.status.draft",
  RUNNING: "partnerAssistant.plan.status.running",
  DONE: "partnerAssistant.plan.status.done",
  PARTIAL: "partnerAssistant.plan.status.partial",
  FAILED: "partnerAssistant.plan.status.failed",
  CANCELLED: "partnerAssistant.plan.status.cancelled",
};

export const STEP_STATUS_KEYS: Record<PlanStepStatus, string> = {
  PENDING: "partnerAssistant.plan.step.pending",
  DONE: "partnerAssistant.plan.step.done",
  FAILED: "partnerAssistant.plan.step.failed",
  SKIPPED: "partnerAssistant.plan.step.skipped",
};

export const DANGER_REASON_KEYS: Record<DangerReason, string> = {
  DELETE: "partnerAssistant.plan.reason.delete",
  UNPUBLISH: "partnerAssistant.plan.reason.unpublish",
  PUBLISHED_PRICE: "partnerAssistant.plan.reason.publishedPrice",
  FINISH_STREAM: "partnerAssistant.plan.reason.finishStream",
  BAN: "partnerAssistant.plan.reason.ban",
  COUNTRY_ACCESS: "partnerAssistant.plan.reason.countryAccess",
  TERMINATE_PURCHASE: "partnerAssistant.plan.reason.terminatePurchase",
  ROLE_ADMIN: "partnerAssistant.plan.reason.roleAdmin",
  ROLE_REMOVE: "partnerAssistant.plan.reason.roleRemove",
  DISABLE_MEMBER: "partnerAssistant.plan.reason.disableMember",
  REMOVES_ITEMS: "partnerAssistant.plan.reason.removesItems",
  MASS_CHANGE: "partnerAssistant.plan.reason.massChange",
  MODEL: "partnerAssistant.plan.reason.model",
};

/**
 * Строки причины опасного шага в карточке плана: текст причины и, если шаг
 * убирает элементы из известных списков, подпись с перечнем полей (для
 * REMOVES_ITEMS она заменяет общий текст). Без причины и полей (старые
 * планы) общая подпись «нужно подтверждение».
 */
export function dangerReasonLines(
  step: { dangerReason?: DangerReason | null; removedFrom: string[] },
  t: (key: string, options?: Record<string, unknown>) => string
): string[] {
  const lines: string[] = [];
  const fields = step.removedFrom.length > 0;
  if (step.dangerReason && !(fields && step.dangerReason === "REMOVES_ITEMS"))
    lines.push(t(DANGER_REASON_KEYS[step.dangerReason]));
  if (fields)
    lines.push(
      t("partnerAssistant.plan.removesFields", {
        fields: step.removedFrom.join(", "),
      })
    );
  return lines.length ? lines : [t("partnerAssistant.plan.needsConfirmation")];
}
